import gql from 'graphql-tag'
export default gql`
query{
    getServiceTags{
      id
      siteId
      tagId
      tagName
      status
      displayOrder
      tagOptions{
        name
        startDate
        validityNo
        validityType
        endDate
        visibleOn
        icon{
          bucket
          region
          key
        }
      }
    }
  }`